import React from "react";
import { useMedia } from "react-media";
import styled from "styled-components";
import ImageGallery from "../../Components/image-gallery";
import { GLOBAL_MEDIA_QUERIES, primaryColors } from "../../constatnts";
import { IMedia } from "../../types/types";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";

interface IPros {
}
const Gallery = (props: IPros) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  const { t, i18n } = useTranslation();

  return (
    <InnerPageLayout>
      <Container {...matches}>
        <Section>
          <h4 className="shape-round mb-lg-5 pb-5">ألبوم الصور</h4>

          <Spacer />
          <ImageGallery />
        </Section>
      </Container>
    </InnerPageLayout>
  );
};
const Section = styled.div`
  position: relative;
  margin-bottom: 34px;
  background: rgb(255, 255, 255);
  padding: 19px 30px 30px;
  box-shadow: rgb(227 233 243) 0px 2px 4px 0px;
  border-radius: 3px;
  line-height: 18px;
`;

const TitleImage = styled.img`
  position: absolute;
  width: 106px;
  top: 0;
  z-index: 0;
  right: -10px;
`;

const Title = styled.h1`
  z-index: 1;
  position: relative;
  margin: 20px 56px;
  color: ${primaryColors[0]};
`;
const Container = styled.div<IMedia>`
  margin: ${(props) => (props.large ? "40px" : "0px")}; ;
`;
const Spacer = styled.div`
  height: 20px;
  width: 20px;
`;
export default Gallery;
